import _styled from "@emotion/styled/base";

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

import * as DesktopNav from '@segment/matcha/recipes/Navigation2/DesktopNavigation';
import NavDropdownBase, * as NavDropdown from '@segment/matcha/recipes/Navigation2/DesktopNavigation/Dropdown';
import { usePageConfig } from '@segment/contexts/page';
import docsData from '../../data/docs';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";

var Docs = function Docs() {
  var pageConfig = usePageConfig();

  var _docsData = docsData(pageConfig),
      content = _docsData.content,
      aside = _docsData.aside;

  return _jsxs(NavDropdownBase, {
    children: [_jsxs(NavDropdown.Content, {
      children: [_jsx(DesktopNav.Subheading, {
        children: content.title
      }), _jsxs(DesktopNav.List, {
        children: [content.links.map(function (item) {
          return _jsx("li", {
            children: _jsx(DesktopNav.Link, {
              title: item.title,
              href: item.url
            })
          }, item.title);
        }), _jsx("li", {
          children: _jsx(HighlightedLink, {
            title: content.highlightedLink.title,
            href: content.highlightedLink.url
          })
        })]
      })]
    }), _jsxs(NavDropdown.Tray, {
      children: [_jsx(DesktopNav.Subheading, {
        children: aside.title
      }), _jsx(DesktopNav.List, {
        children: aside.links.map(function (item) {
          return _jsx("li", {
            children: _jsx(DesktopNav.Link, {
              title: item.title,
              description: item.description,
              href: item.url
            })
          }, item.title);
        })
      })]
    })]
  });
};

var HighlightedLink = /*#__PURE__*/_styled(DesktopNav.LinkHighlighted, true ? {
  target: "elrdwy60"
} : {
  target: "elrdwy60",
  label: "HighlightedLink"
})(true ? {
  name: "hkh81z",
  styles: "margin-top:8px"
} : {
  name: "hkh81z",
  styles: "margin-top:8px",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

export default Docs;